<template>
  <div class="IframeSharing">
    <input type="text" name="" id="iframeUrl" v-model="iframeUrl" onClick="this.setSelectionRange(0, this.value.length)">
    <span v-on:click="copyToClipboard" class="CopyButton" id="clipboard" tabindex="0">
      <img :src="require('@/assets/icons/' + (active ? 'clipboard-check':  'clipboard') + '.svg')" alt="">
    </span>
  </div>
</template>

<script>
import { words } from '@/constants/lang';

export default {
  name: 'IframeSharing',
  data: function() {
    return {
      words,
      active: false
    }
  },
  methods: {
    copyToClipboard () {
      this.active = true
      const el = document.createElement('textarea');
      el.value = document.getElementById('iframeUrl').value;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      let self = this;
      setTimeout(function() {
        self.$store.commit('toggleIframe');
        self.active = false
      }, 3000);
    },
  },
  computed: {
    lang: function () {
      return this.$store.state.language.lang
    },
    iframeUrl: function () {
      return `<section style="height: 100vh;"><iframe width="100%" height="100%" src="` + this.$store.state.fullPath + `" allowfullscreen style="border: none;"></iframe></section>`;
    }
  }
}
</script>

<style lang="less">

  @import "../less/_var.less";

  .IframeSharing {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
    border-radius: 8px 8px;
    background: #292929;
    margin: 0 10px;
    position: relative;
    height: 40px;
    width: calc(100% - 20px);

    input {
      border-radius: 5px 0 0 5px;
      -webkit-appearance: none;
      height: 100%;
      border-width: 0;
      padding: 0 0 0 10px;
      font-family: consolas, monospace;
      color: #464646;
      background: #fff;
      width: 100%;
      border: solid 1px #dadada;
      box-sizing: border-box;
      border-right: none;

      &:focus {
        outline: none;
      }
    }

    span.CopyButton {
      height: calc(100% - 4px);
      width: 36px;
      min-width: 36px;
      height: 100%;
      border: none;
      box-sizing: border-box;
      color: white;
      background: #397476 !important;
      border-radius: 0 5px 5px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      img {
        width: 12px;
        max-height: 20px;
      }
    }
  }

</style>
